import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import type { HubCategory } from './CategoryHub';

interface CategoryPillsProps {
  categories: HubCategory[];
  activeId: string;
  onSelect: (categoryId: string) => void;
}

/** The way to a neighbouring category from inside one: a single scrolling row above the page header. */
export function CategoryPills({ categories, activeId, onSelect }: CategoryPillsProps) {
  const { t } = useTranslation();

  return (
    <nav
      aria-label={t('portal_tests_categories')}
      className="no-scrollbar -mx-4 flex gap-2 overflow-x-auto px-4 md:mx-0 md:px-0"
    >
      {categories.map(({ id, label }) => {
        const active = id.toLowerCase() === activeId.toLowerCase();
        return (
          <button
            key={id}
            type="button"
            aria-current={active ? 'true' : undefined}
            onClick={() => onSelect(id)}
            className={cn(
              'inline-flex h-11 shrink-0 items-center whitespace-nowrap rounded-xl border px-3.5 text-[13px] font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 lg:h-9',
              active
                ? 'border-foreground bg-foreground text-background'
                : 'border-border bg-card text-foreground/75 hover:border-foreground/25 hover:text-foreground',
            )}
          >
            {label}
          </button>
        );
      })}
    </nav>
  );
}

export default CategoryPills;
